// extracted by mini-css-extract-plugin
export default {"brandPromo":"vJ-z","carousel":"wJ-z"};